// extracted by mini-css-extract-plugin
export default {"lede":"Lede-module__lede--Z6dMJ"};